<script setup>
import {computed} from "vue";
import _ from "lodash";

const props = defineProps({
    gift: {
        type: Object,
        required: true,
    },
    selectedGift: {
        type: Object,
        required: false,
    }
});

const emit = defineEmits(['gift-clicked']);

const badgeText = window.Drupal.t('Your free gift!');

const active = computed(() => {
    if (lodash.isNil(props.selectedGift)) {
        return false;
    }

    return _.isEqual(props.selectedGift.sku, props.gift.sku)
});

const handleClick = () => {
    if (active.value) {
        return;
    }

    emit('gift-clicked', props.gift)
}
</script>

<template>
    <div class="vue-gift col-xl-4" :class="{'active': active}">
        <div class="inner" @click="handleClick">
            <div v-if="active" class="badge">{{ badgeText}}</div>

            <img :src="gift.full_image_path" :alt="gift.name" style="max-width: 40%"/>
            <div class="content">
                <p class="title">{{ gift.name }}</p>
                <p class="subtitle" v-if="gift.description">{{ gift.description }}</p>
            </div>
        </div>
    </div>
</template>